"use client"

import "./css/porta.css"
import { Download } from "lucide-react"

// Remover todas las importaciones de imágenes del portafolio
// Agregar la importación del PDF
import portafolioPdf from "../pdf/portafolio.pdf"

import prefooterImage from "../img/prefooter.jpg"

const Porta = ({ onOpenPdfModal }) => {
  const handleOpenCatalog = () => {
    console.log("🔍 Botón clickeado - handleOpenCatalog ejecutado")
    console.log("📁 PDF Path:", portafolioPdf)
    console.log("🔧 onOpenPdfModal función:", onOpenPdfModal)

    if (onOpenPdfModal) {
      console.log("✅ Llamando onOpenPdfModal...")
      onOpenPdfModal(portafolioPdf, "Portafolio Agrocorral")
    } else {
      console.log("❌ onOpenPdfModal NO existe")
    }
  }

  return (
    <>
      <section className="porta-section" id="Porta">
        <div className="porta-content">
          <Download size={48} className="porta-icon" />
          <h2 className="porta-title">Catálogo de Productos</h2>
          <button className="porta-button" onClick={handleOpenCatalog}>
            VER CATÁLOGO
          </button>
        </div>
      </section>

      {/* Nueva sección con imagen a todo el ancho */}
      <section className="prefooter-section">
        <img src={prefooterImage || "/placeholder.svg"} alt="Prefooter" className="prefooter-image" />
      </section>
    </>
  )
}

export default Porta
